import React from "react";
import logo from "./images/logo.svg";
import './Header.css';
import { Link } from "react-router-dom";
import Nav from "./Navigation";
import { publicIpv4 } from 'public-ip';
import { API } from 'aws-amplify'
import { usersByIpAddress } from "../graphql/queries";
import { createUser } from "../graphql/mutations";
import { getUserId } from "../utils/Utils";

function Header() {
  const headerRef = React.useRef(null);
  const [headerHeight, setHeaderHeight] = React.useState();
  const [hamburgerOpen, setHamburgerOpen] = React.useState(false);

  const toggleHamburger = () => {
    let isOpen = !hamburgerOpen;
    setHamburgerOpen(isOpen);
    headerRef.current.style.height = isOpen ? '100vh' : headerHeight;
  }

  const handleLogoClicked = () => {
    if (!hamburgerOpen) {
      return;
    }
    toggleHamburger();
  }

  const getUserId = async () => {
    /*let ipAddress = await publicIpv4();
    console.log(ipAddress);

    const users = await API.graphql({
      query: usersByIpAddress,
      variables: { 'ipAddress': ipAddress }
    });
    console.log(users);
    
    if (users.data.UsersByIpAddress.items.length === 0) {
      console.log('creating user');
      const userDetails = {
        ipAddress: ipAddress
      }; 
      const newUser = await API.graphql({ 
        query: createUser, 
        variables: { input: userDetails }
      });
      console.log(newUser);
    }*/

    let userId = await getUserId();
    console.log('userId: ' + userId);
  }

  React.useEffect(() => {
    setHeaderHeight(headerRef.current.style.height);
  }, []);

  return (
    <section ref={headerRef} className='header'>
      <Link to='/' className='logo' onClick={handleLogoClicked}>
        <img src={logo} alt='Logo' />
      </Link>
      
      <Nav hamburgerOpen={hamburgerOpen} toggleHamburger={toggleHamburger} />

    </section>
  );
}

export default Header;